import AuthAuth0Guard from "./AuthAuth0Guard";

export default AuthAuth0Guard;
